import type { ReactNode } from "react";
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, ChevronsUpDown, Search } from "lucide-react";

export type SortDirection = "asc" | "desc";

export function TableToolbar({query, onQueryChange, placeholder, children}: {
  query: string; onQueryChange: (value: string) => void; placeholder: string; children?: ReactNode;
}) {
  return <div className="table-toolbar"><label className="search-box table-search"><Search size={16}/><input
    value={query} onChange={(event) => onQueryChange(event.target.value)} placeholder={placeholder}/></label>{children}</div>;
}

export function SortHeader({label, value, sort, direction, onSort}: {
  label: string; value: string; sort: string; direction: SortDirection;
  onSort: (value: string) => void;
}) {
  const active = value === sort;
  const Icon = !active ? ChevronsUpDown : direction === "asc" ? ArrowUp : ArrowDown;
  return <th aria-sort={active ? (direction === "asc" ? "ascending" : "descending") : "none"}><button
    className={`sort-header ${active ? "active" : ""}`} onClick={() => onSort(value)}>{label}<Icon size={12}/></button></th>;
}

export function Pagination({page, pageSize, total, onPageChange, onPageSizeChange}: {
  page: number; pageSize: number; total: number;
  onPageChange: (page: number) => void; onPageSizeChange: (pageSize: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const first = total ? (page - 1) * pageSize + 1 : 0;
  const last = Math.min(total, page * pageSize);
  return <footer className="table-pagination"><span>{first}–{last} of {total.toLocaleString()}</span><label>Rows
    <select value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
      {[10, 25, 50, 100].map((value) => <option value={value} key={value}>{value}</option>)}
    </select></label><div><button className="icon-button" aria-label="Previous page" disabled={page <= 1}
      onClick={() => onPageChange(page - 1)}><ArrowLeft size={16}/></button><strong>{page} / {pages}</strong><button
      className="icon-button" aria-label="Next page" disabled={page >= pages}
      onClick={() => onPageChange(page + 1)}><ArrowRight size={16}/></button></div></footer>;
}

export function cycleSort(value: string, current: string, direction: SortDirection): {sort: string; direction: SortDirection} {
  return {sort: value, direction: value === current && direction === "desc" ? "asc" : "desc"};
}
